// extracted by mini-css-extract-plugin
export default {"wrap":"AdvantageList_wrap__F5CCW","list":"AdvantageList_list__WP1F5","item":"AdvantageList_item__3U0IR"};